export const ASSISTANT_REVIEW_ROLES = ["ROLE_ADMIN", "ROLE_SUPER_ADMIN"];
export const isAssistantReviewPortal = () => window.location.pathname.replace(/\/+$/, "") === "/admin";
